/*
 * (C) Copyright 2018-2019 Nuxeo SA (http://nuxeo.com/).
 *   This is unpublished proprietary source code of Nuxeo SA. All rights reserved.
 *   Notice of copyright on this source code does not indicate publication.
 *
 *   Contributors:
 *       Nuxeo
 */
import Vue from 'vue'
import Vuex from 'vuex'
import {insightService} from "@/insight-service";
import wizard from "./wizard"
import metrics from "./metrics"

Vue.use(Vuex);
export const store = new Vuex.Store({
    modules: {
        wizard,
        metrics
    },
    state: {
        snackSuccess: {
            display: false,
            message: 'Success!'
        },
        snackError: {
            display: false,
            message: 'Error'
        },
        allModels: [],
        publishedModels: [],
        favoriteModels: [],
        trainingModels: [],
        lowModels: [],
        modelsPP: {},
        missions: [],
        currentModel: undefined,
        newModel: {},
        showDialog: false,
        projectId: undefined,
        loading: true,
        currentClient: {},
        urlCore: '',
        AIResourcePath: '',
        enrichers: 'favorites,versions,evaluations,jobInfo,subscribedNotifications,versionEvaluations,performance',
    },

    getters: {
        snackSuccess: state => state.snackSuccess,
        snackError: state => state.snackError,
        allModels: state => state.allModels,
        publishedModels: state => state.publishedModels,
        favoriteModels: state => state.favoriteModels,
        trainingModels: state => state.trainingModels,
        lowModels: state => state.lowModels,
        modelsPP: state => state.modelsPP,
        currentModel: state => state.currentModel,
        showDialog: state => state.showDialog,
        projectId: state => state.projectId,
        loading: state => state.loading,
        currentClient: state => state.currentClient,
        missions: state => state.missions,
        urlCore: state => state.urlCore,
        AIResourcePath: state => state.AIResourcePath,
        enrichers: state => state.enrichers,
    },

    mutations: {
        displaySuccess(state, message) {
            state.snackSuccess = {
                display: true,
                message: message
            }
        },

        displayError(state, message) {
            state.snackError = {
                display: true,
                message: message
            }
        },

        displayLoading(state, loading) {
            state.loading = loading;
        },

        setShowDialog(state, show) {
            state.showDialog = show;
        },

        setModels(state, models) {
            state.allModels = models;
            state.trainingModels = [];
            state.publishedModels = [];
            state.favoriteModels = [];
            state.lowModels = [];
            models.forEach((model) => {
                if (insightService.isPublished(model)) {
                    state.publishedModels.push(model)
                }
                if (insightService.isLive(model)) {
                    if (insightService.isTraining(model)) {
                        state.trainingModels.push(model);
                    }
                    if (insightService.isFavorites(model)) {
                        state.favoriteModels.push(model);
                    }
                    if (insightService.isLowPerformance(model)) {
                        state.lowModels.push(model);
                    }
                    state.lowModels.sort((a, b) => a.properties['ai_algorithm:main_evaluation_metric'].value > b.properties['ai_algorithm:main_evaluation_metric'].value ? 1 : -1);
                }
            });
        },

        setModelsPP(state, pageProvider) {
            state.modelsPP = pageProvider;
        },

        setMissions(state, missions) {
            state.missions = missions;
        },

        setCurrentModel(state, currentModel) {
            state.currentModel = currentModel;
        },

        setProjectId(state, projectId) {
            state.projectId = projectId;
        },
        setCurrentClient(state, client) {
            state.currentClient = client;
        },
        setUrlCore(state, urlCore) {
            state.urlCore = urlCore;
        },
        setAIResourcePath(state, AIResourcePath) {
            state.AIResourcePath = AIResourcePath;
        },
    }
});
